import { defineComponent as S, useAttrs as N, computed as o, ref as $, watch as B, openBlock as l, createElementBlock as n, mergeProps as V, unref as i, createElementVNode as r, normalizeClass as c, Fragment as v, renderList as p, createBlock as w, createCommentVNode as u, toDisplayString as f, normalizeStyle as A, renderSlot as I, createTextVNode as x } from "vue";
import E from "./novoui-vuejs10.js";
import { TabsSize as d, getTabsSizeClasses as D, getNormalizedContent as F, getTabsStyleClasses as L } from "./novoui-vuejs64.js";
const P = ["onClick", "disabled"], Y = { key: 1 }, J = /* @__PURE__ */ S({
  __name: "NTabs",
  props: {
    size: { default: d.medium },
    content: { default: void 0 },
    height: { default: void 0 },
    sticky: { type: Boolean, default: !1 },
    activeTabId: { default: void 0 },
    contentClasses: { default: () => [] }
  },
  emits: [
    /**
     * Emits the tab id of the new tab when this tab had been clicked
     */
    "update:currentTab"
  ],
  setup(b, { emit: h }) {
    const { class: g, ...T } = N(), _ = h, t = b;
    function y(s) {
      a.value = s, _("update:currentTab", s);
    }
    const z = o(() => D(t)), m = o(() => F(t.content)), C = o(() => L(t)), a = $(t.activeTabId || t.content && t.content[0].id || "0");
    return B(() => t.activeTabId, (s, k) => {
      a.value = s || a.value;
    }), (s, k) => (l(), n("div", V({
      class: ["tabs-container", i(g)]
    }, T), [
      r("ul", {
        class: c(C.value)
      }, [
        (l(!0), n(v, null, p(m.value, (e) => (l(), n("li", {
          key: e.id
        }, [
          r("button", {
            onClick: (j) => y(e.id),
            class: c([z.value, { "tab-active": a.value === e.id }]),
            disabled: e.disabled
          }, [
            e.icon ? (l(), w(E, {
              key: 0,
              icon: e.icon,
              size: t.size === i(d).large || t.size === i(d).lg && !(e.label && e.label.trim()) ? "normal" : "small"
            }, null, 8, ["icon", "size"])) : u("", !0),
            e.label && e.label.trim() ? (l(), n("span", Y, f(e.label), 1)) : u("", !0)
          ], 10, P)
        ]))), 128))
      ], 2),
      r("div", {
        class: c(["tabs-content", s.contentClasses]),
        style: A({ height: `${t.height}px`, overflowY: t.height ? "auto" : "initial" })
      }, [
        (l(!0), n(v, null, p(m.value, (e) => (l(), n("div", null, [
          e.id === a.value ? I(s.$slots, `tabs_${e.id}`, { key: 0 }, () => [
            x(f(e.content), 1)
          ]) : u("", !0)
        ]))), 256))
      ], 6)
    ], 16));
  }
});
export {
  J as default
};
